












































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import DossierLabels from "./DossierLabels.js";
import { RepositoryFactory } from "./../repositories/RepositoryFactory";

const DossierRepository = RepositoryFactory.get("dossier");

export default Vue.extend({
  name: "changes-list",
  props: {
    wijziging: {
      required: true
    },
    cardName: {
      required: true
    }
  },
  data() {
    return {
      labels: DossierLabels
    };
  },
  methods: {
    isObject(a): boolean {
      return !!a && a.constructor === Object;
    },
    async downloadDossierFile(dossierFile) {
      let res = await DossierRepository.downloadDossierFile(
        dossierFile.pStep,
        dossierFile.pDossierFile
      ).then((response) => {
        let fileURL = window.URL.createObjectURL(response.data);
        let fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", dossierFile.bestandsnaam);
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    }
  }
});
